<template>
	<div>
	  <div class="about">
		<div  :class="'header-image default-header-'+rand">
			<SubTopNav title="Flagship Projects" />	
		</div>
	    
    	<div class="page-content item-grid">

    		<!-- {{ group }} -->
    		
    		<div v-for="item in group" :key="item.nid" class="item animated fadeInUp" @click="getItem(item.alias)">
    			<div class="img" v-if="item && item.field_content_image_s_"><img :src="baseDomain + item.field_content_image_s_" v-if="item.field_content_image_s_"></div>
    			<div class="name">
    				<h3>{{ item.title }}</h3>
    				
    			</div>
    		</div>
		</div>
	    
	  </div>
	  <div :class="['person-profile', 'animated', (showItem ? 'bounceInRight' : 'bounceOutRight')]" v-show="showAnimation">
	  	<div class="person-close-icon" @click="toggleItem()"><i class="fas fa-times fa-2x"></i></div>
	  	<h3>{{ selectedItem.title }}</h3>
	  	<div v-html="selectedItem.body"></div>
	  </div>
  </div>
 
</template>
<script>
// @ is an alias to /src
	import { mapState } from 'vuex' 
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		featuredImage: null,
	  		contentImages: [],
	  		contentBody: [],
	  		title: null,
	  		rand: 1,
	  		tagline: null,
	  		siblings:[],
	  		group: [],
	  		selectedItem: {},
	  		showItem:false,
	  		showAnimation: false
	  	}
	  },
	  methods: {
	  	async getGroup(type){

        	const { data } = await ContentRepository.getGroup(type)
        	this.group = data
     		// console.log('data', data)

        	// this.getSiblings()

       
	  	},
	  	toggleItem(nid){
	  		if (nid){
	  			var selectedArray = this.group.filter(function (item){
		  			return item.nid == nid
		  		});

		  		this.selectedItem = selectedArray[0]
		  		this.selectedItem.content = this.selectedItem.body[0]
		  		this.showItem = true
		  		this.showAnimation = true
	  		} else {
	  			this.selectedItem = {}
	  			this.showItem = false
	  		}
	  		

	  		
	  	},
	  	getItem(alias){
	  		var aliasName = alias.split('/').pop()
	  		var path = '/opportunity/' + aliasName

	  		this.$router.push(path)

	  	},
	  	getSiblings(){
	  		var navigation = this.$session.get('navigation')
	  		var pageTitle = "Our Capabilities"
	  		if (navigation && navigation.length){
	  			var menuItemArr = navigation.filter(function (item){
		          return item.name.toLowerCase() == pageTitle
		        })

		        var menuItem = menuItemArr[0]
		        var menuParent = menuItem.parent


		        if (menuParent){
		        	var siblingsArr = navigation.filter(function (item){
		        		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
		        	})

		        	this.siblings = siblingsArr

		        }
	  		}
	  	}
	  },
	  computed: {
	    ...mapState(['baseDomain'])
	  },
	  mounted(){
	  	// console.log('in mounted opportunities')
	  	// this.getGroup('opportunity')

	  	var api = this.$route.meta.api
	  	if (api && api.length && api.length > 0){
	  		api.forEach(item => {
	  			if (item.type == 'node'){
	  				this.getNode(item.id)
	  			}
	  			if (item.type == 'group'){
	  				this.getGroup(item.id)
	  			}
	  		})
	  		// if (api.type == "node"){
	  		// 	this.getNode(api.id)
	  		// } else if (api.type == "group") {
	  		// 	this.getGroup(api.id)
	  		// } else {

	  		// }
	  	}
	  	
	  	this.rand = Math.floor(Math.random() * 8) + 1 
	  }
	};
</script>
<style scoped>
	


	.masonry.images-0.over3{
		column-count: 3;
  		column-gap: 1em;
  		padding-right: 15px;
	    padding-left: 15px;
	    margin-right: auto;
	    margin-left: auto;
	    margin-top:25px;
	    max-width:75%;
	}

	.masonry.images-0.over3 .content-body{
		background-color: #eee;
		display: inline-block;
		margin: 0 0 1em;
		width: 100%;
		padding:15px;
		border-radius:5px;
	}

	.item{
		xpadding:25px;
		box-shadow:3px 3px 5px #CCC;
		xbackground:url('../assets/navyblue-cnr.png') no-repeat bottom right;
		background-size:25px;
		border-radius:0 0 25px 0;
		margin-bottom:25px;
		cursor:pointer;
		/*display:grid;*/
		height:150px;
		overflow:hidden;
		/*grid-template-columns: 1fr 1fr;*/
	}

	.item img{
		width:100%;
		opacity:0.5;
	}

	.item .img{
		background:#333;
		width:50%;
		float:left;
		margin-top:-150px;
		margin-right:25px;
	}



	.item .name{
		padding:50px;
	}

	.item-grid .item:nth-child(2n) .img{
		float:right;
		margin-right:0;
	}


	.person a{
		color:#6698cb;
	}

	.people{
		display:grid;
		grid-template-columns:1fr 1fr;
		grid-gap:25px;

	}

	.masonry.images-0.over3 .content-body:nth-child(1){
		display:block !important;
		background:rgba(102,152,203,0.3);
	}

	.masonry.images-0.over3 .content-body:nth-child(2){
		background:rgba(204,204,204,0.6);
	}

	.masonry.images-0.over3 .content-body:nth-child(3){
		background:rgba(102,153,51,0.6);
	}

	.masonry.images-0.over3 .content-body:nth-child(4){
		background:rgba(255,102,0,0.2);
	}

	.masonry.images-0.over3 .content-body:nth-child(5){
		background:rgba(102,152,203,0.7);
	}

	.masonry.images-0.over3 .content-body:nth-child(6){
		background:rgba(102,153,51,0.3);
	}

	.default-header{
		background-image:url("../assets/row-1-bg.jpg");
	}

	.page-content{
		text-align:left;
		margin-bottom:30px;
	}

	.image-break{
		height:300px;
		background:#CCC;
		margin-top:35px;
		margin-bottom:35px;
	}

	.image-box{
		height:300px;
		top:0;
		left:0;
		filter: grayscale(100%);
		xopacity:0.3;
	}

	.image-text{
		margin-top:-300px;
		z-index:50;
		position:relative;
	}

	.image-text a{
		color:#FFF;
	}

	/*.body-1, .body-2, .body-3, .body-4, .body-5{
		display:inline-block;
		border:1px solid red;
		padding:10px;
		margin:10px;

	}*/

	.body-0{
		grid-column: 1 / 4;
		margin-bottom:25px;
	}

	.body-1, .body-2, .body-3, .body-4, .body-5{
		box-shadow: 5px 5px 5px #CCC;
		padding:25px;
		border-top: 7px solid grey;
	}

	.body-1{
		border-color:#1b3665;
	}

	.body-2{
		border-color:#669933;
	}

	.body-3{
		border-color:#ff6600;
	}

	.body-4{
		border-color:#6698cb;
	}

	.body-5{
		border-color:#9933cc;
	}


	.masonry{
		display:grid;
		grid-template-columns: repeat(3, 1fr);
		grid-gap:20px;
		

	}

	.image-text .container div{
		background:rgba(27,54,101,0.8);
		color:#FFF;
		padding:105px 50px 50px 50px;
		float:left;
		width:50%;
		height:300px
	}

	.image-text .container div:nth-child(2n){
		float:right;
		background:rgba(102,153,51,0.8);
		
	}

	.body-row{
		xpadding:25px;
	}

	.social-icons{
		xfloat:right;
	}

	.person-profile{
		position:fixed;
		right:0;
		top:0;
		height:100vh;
		z-index:100;
		width:800px;
		max-width:100%;
		text-align:left;
		color:#FFF;
		padding:50px;
		xoverflow-y:scroll;
		/*right:0;
		top:0;
		width:800px;
		max-width:100%;*/
		background:rgba(27,54,101,0.9);
	}


	.person-profile img{
		width:300px;
		float:left;
		margin:0 40px 20px 0;
	}

	.person-profile div{
		margin-bottom:30px;
	}

	.person-icons{
		xfloat:right;
	}

	.person-icons a{
		color:#FFF;
		margin-left:8px;
	}

	.person-close-icon{
		float:right;
		cursor:pointer;
		margin-top:-40px;
		margin-right:-40px;
		margin-left:15px;
	}


	@media (max-width: 768px){

		.item{
			overflow:hidden;
		}

		.item .img{
			margin-top:0px;
			xfloat:none !important;
			position:absolute;
			height:150px;
			overflow:hidden;
			width:90%;
			z-index:-10;
			left:5%;
			margin-right:30px;
			margin:0;
			padding:0;
			border-radius:0 0 25px 0;
		}

		.item .img img{
			opacity:0.2;
		}

		.item .name{
			color:#FFF;
			padding:25px 50px;
		}

	}
</style>